// One owner per block when the app runs inside the theme.
//
// The Liquid sections server-render crawlable copies of blocks the app also renders with live data
// (tier list, key cards, consensus, FAQ, ...). They carry data-mcc-replaced-by="<app kind>".
// A page calls claim(kind) once ITS live data has loaded, which hides those server copies; if the
// engine is offline the page never claims, so the server copies stay as the fallback.
// The SEO h1 + intro always stay with Liquid (see pageTitle() in components/ui.js).

export function claim(kind) {
  try {
    document.querySelectorAll(`[data-mcc-replaced-by~="${kind}"]`).forEach((el) => {
      el.hidden = true;
      el.setAttribute('data-mcc-claimed', '');
    });
  } catch (e) { /* no DOM (tests) */ }
}

export function release(kind) {
  try {
    document.querySelectorAll(`[data-mcc-replaced-by~="${kind}"][data-mcc-claimed]`).forEach((el) => {
      el.hidden = false;
      el.removeAttribute('data-mcc-claimed');
    });
  } catch (e) { /* ignore */ }
}
